import * as Dialog from '@radix-ui/react-dialog';
import { AlertTriangle, Trash2, X } from 'lucide-react';

import { Button } from '@/components/ui/button';

type DeleteConfirmationDialogProps = {
  open: boolean;
  resourceName: string;
  resourceIdentifier?: string;
  onCancel: () => void;
  onConfirm: () => void;
  isLoading?: boolean;
};

export const DeleteConfirmationDialog = ({
  open,
  resourceName,
  resourceIdentifier,
  onCancel,
  onConfirm,
  isLoading = false,
}: DeleteConfirmationDialogProps) => {
  const descriptor = resourceIdentifier ? `${resourceName} ${resourceIdentifier}` : resourceName;
  const message = `Are you sure you want to delete ${descriptor}?`;

  const handleOpenChange = (nextOpen: boolean) => {
    if (!nextOpen) {
      onCancel();
    }
  };

  return (
    <Dialog.Root open={open} onOpenChange={handleOpenChange}>
      <Dialog.Portal>
        <Dialog.Overlay className="fixed inset-0 bg-black/60" />
        <Dialog.Content className="bg-background fixed top-1/2 left-1/2 z-50 w-full max-w-sm -translate-x-1/2 -translate-y-1/2 rounded-lg p-6 shadow-lg">
          <div className="flex flex-col items-center text-center">
            <div className="mb-4 flex h-12 w-12 items-center justify-center rounded-full bg-rose-100 text-rose-600">
              <AlertTriangle className="h-6 w-6" />
            </div>
            <Dialog.Title className="text-lg font-semibold">Delete {resourceName}</Dialog.Title>
            <Dialog.Description className="text-muted-foreground mt-2 text-sm">
              {message}
            </Dialog.Description>
          </div>
          <div className="mt-6 flex justify-center gap-3">
            <Button variant="outline" onClick={onCancel}>
              <X className="h-4 w-4" />
              Cancel
            </Button>
            <Button variant="destructive" onClick={onConfirm} disabled={isLoading}>
              <Trash2 className="h-4 w-4" />
              Delete
            </Button>
          </div>
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root>
  );
};
